import { render, staticRenderFns } from "./PosturasMain.vue?vue&type=template&id=e982946a&scoped=true"
import script from "./PosturasMain.vue?vue&type=script&lang=js"
export * from "./PosturasMain.vue?vue&type=script&lang=js"
import style0 from "./PosturasMain.vue?vue&type=style&index=0&id=e982946a&prod&scoped=true&lang=scss"
import style1 from "./PosturasMain.vue?vue&type=style&index=1&id=e982946a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e982946a",
  null
  
)

export default component.exports